import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { MoreInfoButton } from './MoreInfoButton';

import { InputField, Button, Form } from '@/components';
import useToast from '@/hooks/useToast';
import ROUTES from '@/router/routes';
import { GoldDateRegistration } from '@/services/goldDate';
import { TAPorPremioTO } from '@/types/goldDate';
import { tourneyModalState } from '@/types/tda';
import {
  enterPinTeam11,
  formatNumberToLocale,
  PACKS_BY_NAME,
  validateFieldError,
} from '@/utils';

type PinEntryFormProps = {
  item: TAPorPremioTO;
  pinSugerido?: string;
  pinValue?: string;
  handleTourneyModal: (updates: Partial<tourneyModalState>) => void;
  handleSuccessModal: (updates: Partial<tourneyModalState>) => void;
  successContent: (item: TAPorPremioTO) => JSX.Element;
};

const PinEntryForm = ({
  item,
  pinSugerido,
  pinValue,
  handleTourneyModal,
  handleSuccessModal,
  successContent,
}: PinEntryFormProps) => {
  const navigate = useNavigate();
  const toast = useToast();

  const {
    touched,
    isValidating,
    isValid,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    values,
    handleBlur,
  } = useFormik({
    initialValues: {
      pin: pinSugerido || '',
    },
    validateOnMount: false,
    validateOnBlur: true,
    validationSchema: enterPinTeam11,
    onSubmit: async (val, { setSubmitting }) => {
      if (val.pin) {
        const res = await GoldDateRegistration(val.pin);
        if (res.ok) {
          handleTourneyModal({
            open: false,
            title: '',
            content: null,
            openSuccessModal: true,
          });
          // se setea el modal de éxito
          handleSuccessModal({
            title: item.nombre,
            content: successContent(item),
          });
        } else {
          if (res.codError === 3303) {
            toast.show(
              `No existe cupo para el Torneo de Amigos por Premios seleccionado, en unos minutos podrás participar en otro Torneo de Amigos por ${formatNumberToLocale(
                item.premio ?? 0
              )}`
            );
            handleTourneyModal({
              open: false,
            });
          } else {
            if (res.codError === 3300) {
              toast.show(
                'La inscripción libre ya fue utilizada en este torneo.'
              );
              handleTourneyModal({
                open: false,
              });
            } else {
              toast.show(res.mensaje);
            }
          }
        }
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="flex flex-col items-center content-center mt-4">
      <h1 className="font-semibold text-center">
        {`Necesitás un Pin Especial de $${pinValue} para participar en la Fecha de Oro.`}
      </h1>
      <div className=" items-center content-center space-x-4 mt-4 w-full">
        <Form.Form loading={isSubmitting} onSubmit={handleSubmit}>
          <Form.Field>
            <InputField
              autoComplete="off"
              behavior="default"
              error={validateFieldError(
                touched.pin,
                errors.pin,
                values.pin.length
              )}
              maxLength={12}
              name="pin"
              placeholder="Pin"
              success={!errors.pin && values.pin.length > 0}
              type="text"
              value={values.pin}
              onBlur={handleBlur}
              onChange={handleChange}
            />
          </Form.Field>
          <div className="flex flex-col items-center mt-4">
            <Button
              className="w-full"
              disabled={!isValid || isValidating || !values.pin || isSubmitting}
              type="submit"
              variant="primary"
            >
              Confirmar
            </Button>
            <Button
              className="mt-4 font-bold"
              type="button"
              variant="text"
              onClick={() =>
                navigate(ROUTES.myAccount, {
                  state: PACKS_BY_NAME.PIN_FECHA_ORO,
                })
              }
            >
              Obtener pin especial
            </Button>
            {/* BOTON MAS INFO */}
            <MoreInfoButton className="font-normal" />
          </div>
        </Form.Form>
      </div>
    </div>
  );
};

export default PinEntryForm;
